import React from 'react'

const Spinner = () => {
  return <img alt="spinner" className="loader" src={require("../images/loader.svg")}></img>
}

export default Spinner
